import { Entry } from '../Entry'

export function Entry20231129() {
  return (
    <Entry title="Nov 16 2023 - v3.5.7">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15551/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
